import React from 'react';
import { useQuery } from '@apollo/client';
import { Box, CircularProgress, Alert } from '@mui/material';
import { MY_DASHBOARD_QUERY } from '../graphql/queries';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import MatchmakerDashboard from '../components/dashboard/MatchmakerDashboard';
import FamilyDashboard from '../components/dashboard/FamilyDashboard';
import VendorDashboard from '../components/dashboard/VendorDashboard';

// Overview: a separate dashboard for each role, built from that user's own data
const DASHBOARDS = {
  system_admin: AdminDashboard,
  matchmaker: MatchmakerDashboard,
  bride_family: FamilyDashboard,
  groom_family: FamilyDashboard,
  vendor: VendorDashboard,
};

export default function DashboardOverviewPage() {
  const { data, loading, error } = useQuery(MY_DASHBOARD_QUERY, { fetchPolicy: 'cache-and-network' });
  const dashboard = data?.myDashboard;

  if (loading && !dashboard) return <Box display="flex" justifyContent="center" mt={8}><CircularProgress /></Box>;
  if (error && !dashboard) return <Alert severity="error">{error.message}</Alert>;

  const Dashboard = DASHBOARDS[dashboard?.role];
  if (!Dashboard) return <Alert severity="info">No dashboard is available for your account type.</Alert>;
  return <Dashboard data={dashboard} />;
}
